<script setup lang="ts">
const open = defineModel<boolean>({ default: false });

function onClick() {
  open.value = true;
  trackEvent({
    event: 'navigation',
    event_name: 'cta_click',
    cta_type: 'alert',
    cta_name: 'create_an_alert',
  });
}
</script>

<template>
  <IadStickySmallDevice>
    <IadBtn
      class="w-full"
      size="large"
      :text="$t(`property_serp.notification.create_alert`)"
      @click="onClick"
    />
  </IadStickySmallDevice>
</template>
